import React, {useEffect, useRef, useState} from 'react';
import {Button, Modal} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import {ServerApi} from '../api/ServerApi';

//Стили
import '../Pages/style/palette.css';
import '../Pages/style/common.css';
import './MyModal.css';

//Модальное окно кода подтверждения из смс
export default function MyModal(props) {
    const [isDisabled, setIsDisabled] = useState(true);
    const [value, setValue] = useState('');
    const inputElement = useRef(null);
    const inputRef = useRef(null);
    const serverApi = new ServerApi();
    const navigate = useNavigate();

    //Взять данные input
    const handleChange = (e) => {
        const newValue = e.target.value.replace(/\D/g, '').slice(0, 4);
        setValue(newValue);

        setIsDisabled(newValue.length !== 4);
    };

    //Подтвердить
    const clickHandler = () => {
        props.onHide();
        navigate('/signdocs', {
            state: {
                code: value,
            },
        });
    };

    useEffect(() => {
        if (props.show) {
            inputRef.current.focus();
        }
    }, [props]);

    useEffect(() => {
        if (inputElement.current) {
            inputElement.current.style['caretColor'] = 'transparent';
            inputElement.current.style['webkitTextSecurity'] = 'none';
            inputElement.current.style['textSecurity'] = 'none';
        }
    }, []);

    return (
        <Modal
            {...props}
            size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Введите код из СМС
                </Modal.Title>
                <button type="button" className="btn-close" aria-label="Close" onClick={props.click}/>
            </Modal.Header>
            <Modal.Body>
                <h4 className='my-modal-title text-start weight400_project size14_project color_steel_grey'>
                    На ваш номер телефона было выслано смс с кодом
                </h4>
                <div className="code-input-container w-100 mt-3">
                    <input ref={inputRef} type="number" maxLength="4" value={value} onChange={handleChange}
                           className="code-input w-100 p-0 border-0 text-center" inputMode="numeric"/>
                    <div className="visual-fields d-flex justify-content-between">
                        {[...Array(4)].map((_, index) => (
                            <span key={index}
                                  className={`d-flex justify-content-center align-items-center background_pastel_grey field ${value[index] ? 'filled' : ''} `}>
                                {value[index]}
                            </span>
                        ))}
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className={`w-100 border-0 weight400_project size16_project mt-4 rounded`}
                     style={{
                         backgroundColor: '#eceff1',
                         //borderRadius: '12px'
                }}
                >
                    <Button className={`w-100 border-0 weight400_project size16_project modal_confirm ${isDisabled ? `modal_confirm_true` : `modal_confirm_false`}`}
                            onClick={clickHandler} disabled={isDisabled}>
                        Подтвердить
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};
